import { render, staticRenderFns } from "./SeedoctorKeyword.vue?vue&type=template&id=3070e0c4&scoped=true"
import script from "./SeedoctorKeyword.vue?vue&type=script&lang=js"
export * from "./SeedoctorKeyword.vue?vue&type=script&lang=js"
import style0 from "./SeedoctorKeyword.vue?vue&type=style&index=0&id=3070e0c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3070e0c4",
  null
  
)

export default component.exports